<script setup lang="ts">
import FooterDownloadButton from '@/components/Footer/FooterDownloadButton.vue'
</script>

<template>
  <div class="app">
    <footer-download-button />

    <div class="app__qr">
      <p class="app__text">Наведите камеру на QR-код, чтобы скачать</p>

      <nuxt-img
        src="/footer/footer-app-qr.svg"
        width="64"
        height="64"
        alt="Наведите камеру на QR-код, чтобы скачать"
        loading="lazy"
      />
    </div>

    <p class="app__text">Доступно в AppStore, Google Play, AppGallery</p>
  </div>
</template>

<style lang="scss" scoped>
.app {
  display: grid;
  max-width: 170px;
  font-size: 12px;
  font-weight: 500;
  line-height: 14px;
  color: $text-grey;

  &__qr {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 15px;
    white-space: break-spaces;

    img {
      margin-left: 15px;
    }
  }

  &__text {
    margin: 0;
  }
}
</style>
